import { render, staticRenderFns } from "./appeal.vue?vue&type=template&id=2d7aba70&scoped=true&"
import script from "./appeal.vue?vue&type=script&lang=ts&"
export * from "./appeal.vue?vue&type=script&lang=ts&"
import style0 from "./appeal.vue?vue&type=style&index=0&id=2d7aba70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7aba70",
  null
  
)

export default component.exports